import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {DocumentType} from '../model/document-type.model';
import {Document} from '../model/document.model';

@Injectable()
export class DocumentService {
    constructor(private httpClient: HttpClient, private configService: ConfigService) {
    }

    async create(document: Document): Promise<string> {
        const url = this.configService.baseUrl() + `/user-document`;
        const response: any = await this.httpClient.post<{ id: string }>(url, document).toPromise();
        return response.id;
    }

    public async getDocumentById(documentId: string): Promise<Document> {
        const url = this.configService.baseUrl() + `/user-document/${documentId}`;
        return this.httpClient.get<Document>(url).toPromise();
    }

    public async update(documentId: string, documentType: DocumentType, fileIds: string[]) {
        const url = `${this.configService.baseUrl()}/user-document/${documentId}`;
        await this.httpClient.patch(url, {type: documentType, fileIds: fileIds}).toPromise();
    }
}
